export default __webpack_public_path__ + "static/media/about_background.bb112f75.png";